export const LISTE_COMMANDE = {
  titleCommande: 'Liste des commandes',
  titleEcheancesAFacturer: 'Liste des échéances à facturer',
  titleCommandeBAF: 'Liste des bons à facturer',
  titleCommandeAFacturer: 'Liste des commandes à facturer',
  titleCommandeARenouveler: 'Liste des commandes à renouveler',
  repertoire: 'Commande',
  racine: 'Accueil',
  statusSave: 'Enregistré',
  nonRenouvelable: 'Non renouvelable',
  interne: 'Commande interne',
  tab: {
    commandes: 'Commandes',
    baf: 'Bon à facturer',
    facturer: 'Echéances à facturer',
    commandeAFacturer: 'Commandes à facturer',
    renouvellement: 'A renouveler',
  },
  actions: {
    newQuotation: 'Nouvelle commande',
    drafts: 'Brouillons',
    sent: 'Envoyés',
    accepted: 'Acceptés',
    search: 'Rechercher',
    filtre: 'Filtre',
    indexation: 'Indexer',
  },
  filtre: {
    interne: 'Commande interne',
  },
  table: {
    code: 'Code',
    status: 'Etat',
    date: 'Date',
    customers: 'Clients',
    amountHt: 'Montant HT',
    commercial: 'Commercial(e)',
    folderCode: 'Code dossier',
    datePremierAffichage: 'Date de campagne',
    categorieVente: 'Type de produit',
    etatRenouvellement: 'Renouvellement',
    commentaireInterne: 'Commentaires internes',
    estSigne: 'Signée',
  },
  etat: {
    enregistre: 'Enregistrée',
    facture: 'Facturée',
    facturePartiellement: 'Facturée partiellement',
    sansSuite: 'Sans suite',
    clos: 'Clos',
  },
  indexationMasse: {
    title: 'Indexer des commandes',
    dateIndexation: 'Date d\'indexation',
    indiceReference: 'Indice de référence',
    indiceActuel: 'Nouvel indice',
    messageConfirmation: 'Etes-vous sûr de vouloir indexer ces commandes ?',
    information: 'Informations',
    informationNotIndexable: 'Les commandes suivantes ne sont pas indexable :',
    forceIndexable: 'Forcer l\'indexation de ces commandes ?',
    nomIndice: 'Nom de l\'indice',
  },
};

export const LIST_COMMANDE_COMMISSIONS = {
  actions: {
    annulation: {
      title: 'Voulez-vous annuler la commission ?',
      footer: 'Si la facture est enregistré il y aura un avoir sinon elle sera supprimé',
    },
    facturation: 'Voulez-vous valider la commission ?',
    enregistrement: {
      title: 'Voulez-vous verser la commission ?',
      footer: 'Vous pouvez annuler la commission si besoin',
    },
    generation: {
      title: 'Voulez-vous générer la commission ?',
    },
    changeDate: {
      title: 'Changement de date',
      label: 'Date',
    },
    masquerCommissionsAnt: 'Masquer les commissions antérieures non validées',
    displayCommissionsAnt: 'Afficher les commissions antérieures non validées ({total})',
  },
  history: {
    title: 'Historique des annulations de la commission',
    table: {
      code: 'Code',
      etat: 'Etat',
      creator: 'Utilisateur',
      montant: 'Montant HT',
      date: 'Date',
    },
  },
  etatCommissions: {
    aValider: 'A\u00a0valider',
    aVerser: 'A\u00a0verser',
    versee: 'Versée',
    annulee: 'Annulée',
    annulation: 'Annulation',
  },
  actionsMass: {
    generation: 'Generer commission',
    facturation: 'Valider commission',
    enregistrer: 'Verser commission',
    annulation: 'Annuler',
    changeDate: 'Changer Date',
  },
  table: {
    reference: 'Référence',
    commande: 'Commande',
    remiseBancaire: 'Remise bancaire n°{code}',
    remiseBancaireExterne: 'Remise bancaire',
    referenceEtat: 'Etat',
    planMedia: 'Plan média',
    facture: 'Facture',
    dateDevisCommande: 'Date commande',
    listeIntervenants: 'Commercial',
    etat: 'Etat commande',
    montantCommission: 'Montant commission',
    typeReferenceExterne: 'Type',
    societe: 'Société',
    avance: 'Avance',
    encaissement: 'Encaissement',
    caGaranti: 'CA garanti',
    reversementGaranti: 'Reversement garanti',
    filtre: {
      au: 'au',
      date: 'Date',
      etat: 'Etat',
      commercial: 'Commercial',
      versee: 'Versée',
      type: 'Type de Commission',
      planMedia: 'Plan Média',
      commande: 'Commande',
      facture: 'Facture',
      avecAnnulations: 'Avec annulations',
      vendeurOuFournisseur: 'Vendeur ou Fournisseur',
      vendeur: 'Vendeur',
      fournisseur: 'Fournisseur',
    },
    actions: {
      facturer: 'Valider commission',
      enregistrer: 'Verser commission',
      genererCommissionGarantie: 'Générer commission garantie',
      annuler: 'Annuler',
    },
  },
  referenceExterne: {
    avance: 'Avance',
    encaissement: 'Encaissement',
    vente: 'Vente',
    achat: 'Achat',
    factureFournisseur: 'Avance',
    encaissementFournisseur: 'Encaissement',
  },
  ligneCommande: {
    libelle: 'Produit',
    prixUnitaire: 'Prix unitaire',
    quantite: 'Commissions',
    remise: 'Répartition',
    totalHt: 'Total HT',
    totalTtc: 'Total TTC',
    pourcentageTva: 'Taux TVA',
    montantTva: 'Montant TVA',
  },
  commandeGarantie: {
    regroupementProduit: 'Regroupement produit',
    produit: 'Produit',
    fournisseur: 'Fournisseur',
    commissionGarantieDejaGeneree: 'Commission déjà générée. Retrouvez la dans Com. fournisseur',
  },
};

export const RENOUVELLEMENT_COMMANDE = {
  periode: 'Période',
  dateDebutToDateFin: '{dateDebut} au {dateFin}',
  au: 'au',
  filtre: {
    title: 'Filtre',
    etat: 'Etats de renouvellement',
    code: 'Code dossier',
    numeroCommande: 'N° commande',
    payeur: 'Payeur',
    annonceur: 'Annonceur',
    commercial: 'Commercial',
    assistant: 'Assistant',
    periode: 'Période',
    parDateDe: 'Par date de',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    theme: 'Thème',
    tags: 'Tags',
    dateCampagne: 'Date campagne',
    reconductible: 'Reconductible',
    interne: 'Interne',
    estSigne: 'Signée',
    estSigneElectroniquement: 'Signée électroniquement',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    choixDates: {
      renouvellement: 'Renouvellement',
      preavis: 'Préavis',
    },
    error: {
      dateWithFilterTypeEmpty: 'Le type de date est obligatoire pour filtrer sur une période.',
      filterTypeWithEmptyDate: 'La période est obligatoire pour filtrer par date.',
    },
  },
  popUpMotifNonRenouvellement: {
    title: 'Motif de non renouvellement',
    motif: 'Motif',
    error: {
      motif: 'Motif',
    },
  },
  table: {
    etat: 'Etat',
    numeroCommande: 'N° de commande',
    codeDossier: 'Code Dossier',
    commercial: 'Commercial',
    payeur: 'Payeur',
    annonceur: 'Annonceur',
    montantHt: 'Montant HT',
    dateRenouvellement: 'Date de renouvellement',
    datePreavis: 'Date de préavis',
    actions: 'Actions',
    dateDemande: 'Date de demande',
    motifNonRenouvellement: 'Motif de non renouvellement',
    agence: 'Agence',
  },
  actions: {
    renouveler: 'Renouveler',
    marquerRenouvele: 'Marquer comme \'Renouvelée\'',
    pasRenouveler: 'Ne pas renouveler',
    reconduireTacitement: 'Reconduire tacitement',
    marquerReconduitTacitement: 'Marquer comme \'Reconduite tacitement\'',
    marquerEnCoursRenouvellement: 'Marquer comme \'En cours de renouvellement\'',
    marquerPasRenouveler: 'Marquer comme \'Ne pas renouveler\'',
    aRenouveler: 'A renouveler',
    search: 'Rechercher',
    filtre: 'Filtre',
    enCours: 'En cours de renouvellement',
    exportColonne: 'Exporter par colonne',
  },
  etat: {
    renouvele: 'Renouvelé',
    nonRenouvele: 'Non renouvelé',
    tacite: 'Reconduit tacitement',
    aRenouveler: 'A renouveler',
    enCours: 'En cours de renouvellement',
  },
  changeEtatSucess: 'L\'état de renouvellement de la commande a bien été modifié.',
  messages: {
    success: {
      changeEtatRenouveleMultiCommande: 'Les commandes ont été passées à l\'état \'Renouvelée\' avec succès',
      changeEtatRenouvele: 'La commande a été passée à l\'état \'Renouvelée\' avec succès',
      changeEtatTaciteMultiCommande: 'Les commandes ont été passées à l\'état \'Reconduit tacitement\' avec succès',
      changeEtatTacite: 'La commande a été passée à l\'état \'Reconduit tacitement\' avec succès',
      changeEtatEnCoursMultiCommande: 'Les commandes ont été passées à l\'état \'En cours de renouvellement\' avec succès',
      changeEtatEnCours: 'La commande a été passée à l\'état \'En cours de renouvellement\' avec succès',
      changeEtatNePasRenouvelerMultiCommande: 'Les commandes ont été passées à l\'état \'Ne pas renouveler\' avec succès',
      changeEtatNePasRenouveler: 'La commande a été passée à l\'état \'Ne pas renouveler\' avec succès',
    },
    error: {
      badEtatForChangeEtatRenouvele: 'Les commandes suivantes ne peuvent pas être passées à l\'état \'Renouvelé\' :',
      badEtatForChangeEtatRenouveleDes: 'Veuillez les passer à l\'état \'En cours de renouvellement\' ou \'A renouveler\'',
      badEtatForChangeEtatTacite: 'Les commandes suivantes ne peuvent pas être passées à l\'état \'Reconduite Tacitement\' :',
      badEtatForChangeEtatTaciteDes: 'Veuillez vérifier qu\'elles soient à l\'état \'En cours de renouvellement\' ou \'A renouveler\' et qu\'elles soient reconductibles',
      badEtatForChangeEtatEnCours: 'Les commandes suivantes ne peuvent pas être passées à l\'état \'En cours de renouvellement\' :',
      badEtatForChangeEtatEnCoursDes: 'Veuillez les passer à l\'état \'A renouveler\'',
      badEtatForChangeEtatNePasRenouveler: 'Les commandes suivantes ne peuvent pas être passées à l\'état \'Ne pas renouveler\' :',
      badEtatForChangeEtatNePasRenouvelerDes: 'Veuillez les passer à l\'état \'En cours de renouvellement\' ou \'A renouveler\'',
    },
  },
  totaux: {
    patrimoine: 'Total location : ',
    horsTlpe: 'Total divers : ',
    tlpe: 'Total TLPE : ',
    total: 'Total',
  },
};

export const COMMANDE_BAF = {
  tab: {
    nCommande: 'N° commande',
    patrimoine: 'Patrimoine(s)',
    typeProduit: 'Type(s) produit',
    fournisseur: 'Fournisseur(s)',
    annonceur: 'Annonceur(s)',
    Payeur: 'Payeur',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    montantHt: 'Montant HT',
    assistant: 'Assistant',
    baf: 'BAF',
    dateBaf: 'Date de BAF',
    quiBAF: 'Qui BAF',
    aFacturer: 'A facturer',
    facture: 'Facturé',
    multiPatrimoine: 'Multi-patrimoines',
    multiProduit: 'Multi-produits',
    codeDossier: 'Code dossier',
    childrow: {
      patrimoine: 'Patrimoine(s)',
      typeProduit: 'Type(s) produit',
    },
  },
  popUpPrevention: {
    title: 'Etes-vous sûr de vouloir changer l\'état du BAF ?',
    titleMultiple: 'Etes-vous sûr de vouloir changer l\'état du BAF des lignes sélectionnées ?',
  },
  success: {
    changementEtatSuccess: 'Changement d\'état appliqué avec succès.',
  },
  actions: {
    activerBaf: 'BAF',
    bafCancel: 'Annuler le BAF',
  },
  filtre: {
    error: {
      messageErrorDateBaf: 'La date de début est plus grande que la date de fin',
    },
    fournisseur: 'Fournisseur(s)',
    annonceur: 'Annonceur(s)',
    payeur: 'Payeur(s)',
    dateBaf: 'Date BAF',
    date: 'Date',
    baf: 'BAF',
    quiBaf: 'Qui à BAF',
    facturationFaite: 'Facturé',
    aFacturer: 'A facturer',
    au: 'au',
    assistant: 'Assistant(s)',
    typeProduit: 'Type produit',
    patrimoine: 'Patrimoine',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    theme: 'Thème',
  },
};

export const EDITION_COMMANDE = {
  title: 'Ajouter une commande',
  issuTacite: '- Commande issue d\'une reconduction tacite',
  issuRenouvellement: '- Commande issue d\'un renouvellement',
  updateTitle: 'Modifier la commande {etat} n°{code}',
  updateBreadcrumbTitle: 'Modifier commande',
  problemOccurred: 'Un problème est survenu',
  editSettlement: 'Modifier le mode de règlement',
  modeSettlement: 'Mode de règlement',
  periodSettlement: 'Délai de règlement',
  anyArticle: 'Aucun article n\'est présent,',
  addArticle: 'ajouter facilement vos articles avec les boutons d\'actions ci-dessous',
  show: 'Consulter',
  errors: {
    pasDeDate: 'Vous devez sélectionner une période',
  },
  popUpProduct: {
    title: 'Les lignes suivantes n\'ont pas de produit. Etes-vous sûr de vouloir sauvegarder ?',
  },
  actions: {
    show: 'Consulter',
    revert: 'Annuler',
    bill: 'Facturer',
    addClient: 'Créer un client',
    add: 'Ajouter',
    addLine: 'Ajouter une ligne',
    addSubTotal: 'Ajouter un sous total',
    addComment: 'Ajouter une ligne de texte',
    addFace: 'Face unitaire',
    addRemise: 'Ajouter une remise',
    addNetwork: 'Ajouter un réseau',
    end: 'Terminer',
    edit: 'Modifier',
    delete: 'Supprimer',
  },
  renouvellement: {
    title: 'Renouvellement',
    etatRenouvellement: 'Etat renouvellement :',
    labelRenouvellement: 'Renouvellement commande',
    labelReconduction: 'Reconductible tacitement',
    labelDateRenouvellement: 'Date renouvellement',
    motifNonRenouvellement: 'Motif de non renouvellement :',
    labelDatePreavis: 'Date préavis',
    labelRenouvellementDetail: 'Renouvellement commande :',
    labelReconductionDetail: 'Reconductible tacitement :',
    labelDateRenouvellementDetail: 'Date de renouvellement :',
    labelDatePreavisDetail: 'Date de préavis :',
    labelDemandeRenouvellementDetail: 'Date de demande :',
    renouvelable: 'Renouvelable',
    reconductible: 'Reconductible tacitement',
    yes: 'Oui',
    no: 'Non',
    nonRenouvelable: 'Non renouvelable',
  },
  ordreTravail: {
    title: 'Ordre(s) de travail',
    tab: {
      ot: 'Ordre de travail',
      dateAffichage: 'Date d’affichage',
      afficheur: 'Nom de l’afficheur',
      facePrevue: 'Nb faces prévues à l’affichage',
      faceAffiche: 'Nb faces affichées',
      nbgrattage: 'Nb de grattage effectué',
      listeAffichage: 'Liste d’affichage',
      etat: 'Etat',
    },
    tooltip: {
      facePrevue: '{nFacesPrevuesCmd} face(s) prévue(s) pour la commande pour un total de {nFacesPrevuesTotal} face(s) prévue(s) sur l\'OT',
      faceAffiche: '{nFacesAfficheesCmd} face(s) affichée(s) pour la commande pour un total de {nFacesAfficheesTotal} face(s) affichée(s) sur l\'OT',
      grattage: '{nGrattageEffectuesCmd} grattage(s) effectué(s) pour la commande pour un total de {nGrattageEffectuesTotal} grattage(s) effectué(s) sur l\'OT',
    },
    actions: {
      exportExcel: 'Exporter retour d\'affichage',
      exportPicture: 'Exporter photos',
      diaporama: 'Diaporama',
    },
    validation: {
      noOt: 'Il n\'y a pas d\'ordre(s) de travail',
      noPicture: 'Il n\'y a pas de photos liés au(x) ot(s) de cette commande',
      noRetourAffichageOnDiapo: 'Il n\'y a pas de photos de retours d\'affichage liés au(x) OT(s) de cette commande',
    },
  },
  generalTitle: {
    generalInformations: 'Informations générales',
    clientsSelect: 'Sélection des clients',
    commissionsCommercial: 'Commissions des commerciaux',
    achat: 'Achats',
    articles: 'Articles',
  },
  informations: {
    commercialName: 'Nom commercial',
    categorieVente: 'Type de produit',
    agence: 'Agence',
    role: 'Rôle',
    postalAddress: 'Adresse postale',
    quotationDate: 'Date de signature',
    estSigne: 'Signée',
    validityDate: 'Date de validité',
    trade: 'Commercial(e)',
    theme: 'Thème / Objet',
    assistant: 'Assistant(e)',
    customerReference: 'Référence client',
    product: 'Produit',
    aucunCommercial: 'Aucun(e) commercial(e) sélectionné(e)',
    datePremierAffichage: 'Date de campagne',
    aucunAssistant: 'Aucun(e) assistant(e) sélectionné(e)',
    rate: 'Tarif',
    wording: 'Libellé',
    quantity: 'Qté',
    unitaryCost: 'P.U.',
    discount: 'Remise',
    percentageTva: '% TVA',
    totalHt: 'Total HT',
    totalHtDiscount: 'Total HT remisé',
    internCommentary: 'Commentaires internes',
    intracomCommentary: 'Commentaire intracommunautaire',
    quotationCommentary: 'Commentaires commande',
    adresseLivraison: 'Adresse de livraison',
    totalTtc: 'Total TTC',
    totalTva: 'T.V.A.',
    displayDate: 'Dates d\'affichage',
    from: 'Du',
    to: 'Au',
    occupationPercentage: 'Pourcentage d\'occupation',
    subTotalHt: 'Sous-total HT',
    dontHaveSettlementPeriod: 'Le délai de règlement n\'est pas renseigné',
    dontHaveSettlementMode: 'Le mode de règlement n\'est pas renseigné',
    addText: 'Insérer votre texte',
    penalty: 'En cas de retard de paiement, application d\'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008.',
    penaltyLabel: 'Taux de pénalité',
    recovery: 'En cas de retard de paiement, application d’une indemnité forfaitaire pour frais de recouvrement de 40€ selon l\'article D. 441-5 du code du commerce.',
    recoveryLabel: 'Frais de recouvrement',
    discountRate: 'Pas d’escompte applicable.',
    discountRateLabel: 'Taux d\'escompte',
    folderCode: 'Code dossier',
    tags: 'Tags',
    tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
    commission: 'Commission',
    planMedia: 'Plan Média',
    regleFacturation: {
      label: 'Règle de facturation :',
      erreur: "La règle de facturation n'est pas cohérente avec les lignes de ventes",
    },
    campagne: 'Campagne',
  },
  table: {
    customer: 'Client',
    settlement: 'Règlement',
    address: 'Adresse commerciale',
    percentageOfBilling: 'Quote-part facturation',
    advertiser: 'Annonceur',
    mandatary: 'Mandataire',
    originator: 'Donneur d\'ordre',
    payer: 'Payeur',
    delete: 'Supprimer',
  },
  messages: {
    commandeHasBesoins: 'La commande contient des besoins. Vous devez modifier manuellement les besoins liés à cette commande en cas de modification de cette dernière.',
    successCreation: 'Création de la commande réalisée avec succès.',
    errorCreation: 'Enregistrement du client impossible. Les champs suivants doivent être renseignés : ',
    editQuotationSuccess: 'Modification de la commande réalisée avec succès.',
    successCustomerCreation: 'Création du client réalisé avec succès.',
    billInProgress: 'La facturation est en cours de développement, elle ne gère pas encore la gestion des échéanciers.',
    errors: {
      ligneCommandeDeleteError: 'Une erreur est survenue lors de la suppression d\'une ligne de commande. Veuillez vérifier le bloc d\'erreur pour plus d\'informations.',
      deleteLigneWithEcheanceFacture: 'Impossible de supprimer une ligne liée à une échéance déjà facturée',
      deleteLigneWithBesoin: 'Impossible de supprimer une ligne liée à un besoin. Veuillez supprimer les besoins liés à cette ligne.',
    },
  },
  clients: {
    searchClient: 'Ajouter un client',
  },
  tabs: {
    quotation: 'Commande',
    commissions: 'Commissions commercial',
    logistique: 'Logistique',
    previsualisation: 'Paramétrage édition',
    echeancierFacturation: 'Echéancier de facturation',
    achat: 'Achats',
    etatSuiviDevisCommande: 'Suivi administratif',
  },
  ligne: {
    singleDay: 'jour',
    multiDays: 'jours',
    dateFrom: 'Du',
    dateTo: 'Au',
  },
  logistique: {
    saleProduct: 'Produits vendus',
    datesUpdate: 'Modifier les dates',
    anyArticleTitle: 'Aucun produit présent,',
    anyArticleText: 'Les produits vendus dans cette commande ne peuvent être modifiés',
    instructionPose: 'Instruction de pose',
    parutionInfo: 'Parution {code} du {date}',
    gestionBat: 'Gestion des BAT',
    visuelDemande: 'Visuel demandé',
    visuelRecu: 'Visuel reçu',
    etatBat: 'Etat BAT :',
    dateEnvoie: 'Date d\'envoi :',
    ajoutProduitFace: 'Ajouter face unitaire',
    ajoutProduitFaceNum: 'Ajouter face numérique',
    pourcentageSurface: '% de surface',
    affichesLivrees: 'Affiches réceptionnées',
    dateLivraison: 'Date de livraison',
    nePasReafficher: 'Ne pas réafficher',
    aIntegrerDansLaLogistique: 'Pris en compte en logistique d\'affichage',
    logistiqueVerrouillee: 'Verrouillage de la logistique',
    posePlanification: 'Pose planifiée le : ',
    demandeIntervention: 'Demandes d\'intervention : ',
    otTechnique: 'OT techniques : ',
    affectations: 'Affectations : ',
    info: {
      dateAffichageDiffDatePlanifie: 'La date de début de la ligne de vente est différente de la date de pose planifiée',
      isAffecteLogistiquement: 'L\'affectation logistique de la ligne a déjà été validée',
    },
    libelleLogo: 'Logo ligne commande presse: {name}',
    editionBat: 'PDF BAT',
    batRepasse: 'Repasse',
    dateBatCreation: 'Création à faire pour le',
    dateBatModification: 'Modification à faire pour le',
    dateBatFormat: 'Mise au format à faire pour le',
    gestionCheminFer: 'Gestion du chemin de fer',
    voirAffectation: 'Voir les affectations logistiques',
    affectationsLogistiques: 'Affectations logistiques : ',
    demandeImpresssion: 'Demandes d\'impression : ',
  },
  achats: {
    titleMessage: 'Informations',
    message: 'Un regroupement personalisé n\'est pas affichable dans cet onglet, '
      + 'il faut dissocier la ligne de regroupement pour le voir apparaître',
    messageNoLigne: 'Aucun produit de la commande n\'est affichable, veuillez modifier votre commande',
    description: 'Description',
    montantHt: 'Montant HT',
    fournisseur: 'Fournisseur',
    aFacturer: 'A facturer',
    modeReglement: 'Mode de règlement',
    dateReglement: 'Date de règlement',
  },
  indexation: {
    title: 'Indexation',
    nomIndice: 'Nom de l\'indice',
    personnalise: 'Personnalisé',
    dateDerniereIndexation: 'Date dernière indexation',
    valeurReference: 'Valeur de Référence',
  },
  logistiqueImpression: {
    visuel: 'Visuel',
    impression: 'Impression',
    faconnage: 'Façonnage',
    expedition: 'Expédition',
    iNeedToPrintPosters: 'J\'ai besoin d\'imprimer des affiches',
    commande: {
      title: 'Commande',
      table: {
        visuel: 'Visuel',
        quantite: 'Quantité',
        etat: 'Etat',
      },
    },
    recapitulatif: {
      title: 'Récapitulatif par format d\'affiche',
      table: {
        produitAchat: 'Produit d\'achat',
        formatAffiche: 'Format d\'affiche',
        natureSupportAfficheId: 'Nature support d\'affiche',
        typeMaterielId: 'Type matériel',
        nbAfficheVendue: 'Qté affiches vendues',
        nbAfficheMaintenance: 'Qté maintenance',
        nbAfficheTotal: 'Qté totale',
      },
    },
    affiches: {
      title: 'Affiches',
      table: {
        libelle: 'Campagne',
        produitAchat: 'Produit d\'achat',
        formatAffiche: 'Format aff.',
        natureSupportAfficheId: 'Nature support',
        typeMaterielId: 'Type matériel',
        largeur: 'Largeur',
        longueur: 'Hauteur',
        produit: 'Produit',
        anneeSemaineDepart: 'Sem.',
        etat: 'Etat',
        dateDepart: 'Dte. dép.',
        visuel: 'Visuel',
        nbAfficheVendue: 'Nb. aff.',
        nbAfficheMaintenance: 'Maint.',
        nbAfficheTotal: 'Tt. aff.',
        commentaire: 'Commentaire',
        tiersDestinataire: 'Fournisseur',
        lieuLivraisonPrestation: 'Lieu livr.',
        dateLivraison: 'Dte. livr.',
        commandeAchat: 'Cmd. achat',
      },
      filtre: {
        produit: 'Produit(s) d\'achat',
        formatAffiche: 'Format d\'affiche(s)',
        natureSupport: 'Nature support(s)',
        materielType: 'Type matériel(s)',
        tiersDestinataire: 'Fournisseur(s)',
        lieuLivraisonPrestation: 'Lieu(x) de livraison(s)',
        dateLivraison: 'Date de livraison(s)',
        commande: 'Commandé',
        commandeAchat: 'Commande(s) d\'achat',
      },
      addBesoin: 'Ajouter un besoin',
      genererCommandeAchat: 'Commander',
      decommander: 'Annulation commande',
      editerBesoinEnMasse: 'Mise à jour des informations des besoins',
      deleteAllPopUpHeader: 'Suppression de besoin(s)',
      deleteAllPopUpDescription: 'Etes-vous sûr de vouloir supprimer ce(s) besoin(s) ?',
      duplicateAllPopUpHeader: 'Duplication de besoin(s)',
      duplicateAllPopUpDescription: 'Etes-vous sûr de vouloir dupliquer ce(s) besoin(s) ?',
      generateAllPopUpHeader: 'Génération de commande(s)',
      generateAllPopUpDescription: 'Etes-vous sûr de vouloir commander ce(s) besoin(s) ?',
      besionCannotBeRemoved: 'Le besoin ne peut être supprimé car il est lié à une commande d\'achat',
      besionCannotBeGenerated: 'Le besoin ne peut être généré car aucune vente réseau n\'a été trouvée',
      besionCannotBeModified: 'Le besoin ne peut être modifié car il est lié à une commande d\'achat',
      besionCannotBeOrderedWithoutDeliveryDate: 'Le besoin ne peut être commandé sans date de livraison',
      besionCannotBeOrderedWithoutDeliveryPlace: 'Le besoin ne peut être commandé sans lieu de livraison',
      besionCannotBeOrderedWithoutProduct: 'Le besoin ne peut être commandé sans produit',
      besionCannotBeOrderedWithoutQuantity: 'Le besoin ne peut être commandé sans quantité',
      besionCannotBeOrderedWithoutSupplier: 'Le besoin ne peut être commandé sans fournisseur',
      besionCannotBeOrderedAgain: 'Le besoin ne peut être re-commandé car il est lié à une commande d\'achat',
      advancedSearchFournisseur: 'Recherche avancée du destinataire',
      advancedSearchLieuLivraisonPrestation: 'Recherche avancée du lieu de livraison',
      cellCanNotBeEdited: 'La cellule ne peut pas être éditée car le besoin est lié à une commande d\'achat',
    },
    etat: {
      commande: 'Commandée',
    },
    popUpMiseAjour: {
      title: 'Mise à jour des informations des besoins',
      produitAchat: 'Produit d\'achat',
      tiersDestinataire: 'Fournisseur',
      lieuLivraisonPrestation: 'Lieu de livraison',
      dateLivraison: 'Date de livraison',
      priseEnCompte: 'Prise en compte',
      success: 'Mise à jour des informations des besoins effectuée avec succès',
    },
  },
};

export const FACTURATION_COMMANDE = {
  facturationCommandeZero: 'La facturation a été effectuée avec succès. Aucune facture n\'a été générée',
};
export const VALIDATION = {
  multiAnnonceur: 'Multi-annonceurs non autorisé par les produits dispositifs',
  noDispoForParution: 'La parution {parution} n\'est pas disponible avec ce produit à cette date',
  anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
  suppProduitRegroupementInCreateCommandeFromDevis: 'Impossible de supprimer une ligne de vente réseau lors de la création de commande issue d\'un devis. Veuillez faire la modification sur le devis',
  echeancierError: 'Générez votre échéancier pour enregistrer votre commande.',
  qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
  notProposableLc: 'La face {ref} n\'est pas proposable en vente LC',
  sansSuiteForbiddenWithOrder: 'Impossible de classer cette commande sans suite car un ou des acomptes sont rattachés à cette commande. ',
  sansSuiteForbidenRenewedActif: 'Impossible de classer sans suite une commande renouvelée ou reconduite tacitement.',
  sansSuiteForbidenWithOrdreTravail: 'Impossible de classer sans suite une commande liée à un ordre de travail d\'affichage.',
  sansSuiteForbidenWithTfs: 'Impossible de classer sans suite cette commande car il y a des affectations logistiques sur une de vente interne liées.',
  dateRenouvellementObligatoire: 'La date de renouvellement est obligatoire si la commande est renouvelable.',
  datePreavisObligatoire: 'La date de préavis est obligatoire si la commande est renouvelable.',
  datePreavisForbiddenWithoutRenouvelable: 'La date de préavis ne doit pas être renseignée si la commande n\'est pas renouvelable.',
  dateRenouvellementForbiddenWithoutRenouvelable: 'La date de renouvellement ne doit pas être renseignée si la commande n\'est pas renouvelable.',
  sameProduct: 'Impossible d\'ajouter le même produit à la même date',
  leastOneCustomer: 'Vous devez sélectionner au moins un client par commande.',
  fusionEcheancierVenteInterne: 'Si vous vendez un produit d\'une autre société, vous ne pouvez pas avoir un échéancier regroupé',
  needDiscount: 'Vous devez renseigner la remise',
  normalLine: 'Une ligne de commande est nécessaire entre 2 lignes de remises',
  leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par commande.',
  leastOnePayer: 'Vous devez indiquer au minimum un payeur par commande.',
  pourcentageDivision: 'La somme des pourcentages de facturation des payeurs doit être égale à 100%.',
  amountDivision: 'La somme des quotes-parts de facturation doit être égale au montant total de la commande.',
  proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur une même commande.',
  unitPriseLessZero: 'Le prix unitaire des produits doit être supérieur à 0.',
  quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
  discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100.',
  discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci.',
  leastOneProduct: 'Vous devez saisir au minimum un produit dans la commande.',
  leastOneProductInQuotation: 'Il doit y avoir au moins un produit dans le devis de la commande.',
  notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type.',
  saveImpossible: 'Enregistrement de la commande impossible.',
  editImpossible: 'Modification de la commande impossible.',
  agenceId: 'Vous devez sélectionner une agence.',
  sumMontantAcompteGreat: 'La somme des montants des acomptes dépasse le montant total de la commande.',
  sumMontantAcompteGreatForOrder: 'La somme des montants des acomptes dépasse le montant total de la commande {commandeId}.',
  acompteMultipayeurForbidden: 'Le multipayeur est impossible avec des commandes ayant des acomptes.',
  faceDateOverlap: 'Impossible de vendre la même face dans la même commande avec des dates se chevauchant',
  LesLignesDansUnRegroupementPersonnaliseMemeTva: 'Les lignes faisant partie d\' un regroupement personnalisé doivent avoir le même taux de TVA',
  updateForbiddenIfLogisticAssignment: 'Impossible de modifier une ligne de commande si son affectation logistique a déjà été validée',
  ShoudContainsLocationOrBillBoard: 'La vente doit contenir au moins une ligne',
  TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de la vente',
  insuficientStock: 'Le produit n\'est pas disponible aux dates demandées',
  insuficientStockYearweek: 'Le produit \'{produit}\' n\'est pas disponible à la semaine {week} pour la quantité souhaitée',
  insuficientStockDated: 'Le produit \'{produit}\' n\'est pas disponible du {dateDebut} au {dateFin}.',
  echeancierErrorGeneration: 'Un échéancier est en cours de création, veuillez finir de le générer ou l\'annuler',
  closingLineAfterDate: 'Une ligne de commande a une date de début après la date de clôture',
  closingDateMandatory: 'La date de clôture est obligatoire',
  closingScheduleAfterDate: 'Un échéancier a une date de début après la date de clôture',
  closingWrongState: 'La commande doit être à l\'état "facturée" ou "facturée partiellement"',
  renouvellableRequiredIfReconductible: 'La reconduction tacite nécessite que la commande soit renouvelable',
  noTempoSaleWithManual: 'Vous ne pouvez ajouter des lignes de ventes avec un réseau temporaire à votre commande',
  faceNotAvailable: 'Une des faces sélectionnées dans un réseau n\'est pas disponible',
  faceNotAvailableInSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine}',
  faceDelete: 'La face {face} a été enlevée de la sélection pour le réseau {reseau} à la semaine {semaine} car elle n\'est pas disponible',
  sameFaceInSameWeek: 'La même face ne peut pas être sélectionnée à la même période sur différents réseaux',
  faceSelectGreaterThanFaceWish: 'Le nombre de faces sélectionnées est plus grand que le nombre de faces souhaitées',
  lineMustBeBloque: 'Pour sélectionner des faces, l\'état d\'option et blocage de la ligne doit être à "bloqué"',
  devisCommandeNotCancel: 'Le devis ou la commande ne doit pas être annulé',
  parutionCheminDeFer: 'La commande ne peut pas être modifiée, un encart est placé dans un chemin de fer',
  onlyOnePayeur: 'Impossible d\'avoir plusieurs payeurs si le role est différent de \'Régie\'',
  noRegroupementPerso: 'Impossible d\'avoir un regroupement personalisé si le le role est différent de \'Régie\'',
  echeancierManuelShouldHaveEcheancierLignes: 'Un échéancier manuel doit avoir des lignes d\'échéanciers',
  googleMapKeyInvalid: 'La clef API google est invalide',
  deleteBilledLine: 'Impossible de supprimer une ligne liée à un échéancier de facturation',
  sameBillingType: 'Les lignes de commande de l\'échéancier doivent avoir le même type de facturation',
  noMoreOneHundred: 'Le total des commissions ne doit pas faire plus que 100%',
  parutionNeeded: 'La parution est obligatoire pour le produit: {produit}',
  oneCommercialBycom: 'Il n\'est pas possible de cumulé les commissions pour un commercial',
  etatDemandeShouldBeTrue: 'L\'état de la demande doit être correctement envoyé',
  sameSupplier: 'Les lignes de commande de l\'échéancier doivent avoir le même fournisseur',
  supplierNotAllowedIfRegie: 'Si la société ne contient que le rôle régie, aucun fournisseur n\'est autorisé sur la ligne de commande',
  prospectNotAllowed: 'Impossible d\'enregistrer une commande avec un intervenant prospect',
  noOrderLinkedToBill: 'La facture n\'est pas liée à une commande',
  remiseInterditeVenteInterne: 'Interdit d\'ajouter une ligne de remise lorsque l\'on vend un produit d\'une autre société',
  remiseInterditeCompta: 'Interdit d\'ajouter une ligne de remise',
  wrongSigneEcheancier: 'Problème de signe sur les échéances',
  tvaNotInRange: 'La TVA avec la valeur {tva} ne fait pas partie des régimes de TVA connus',
  name: {
    motifNonRenouvellement: 'Motif de non renouvellement',
    libelleLigneCommande: 'Libellé de la ligne',
    quantiteLigneCommande: 'Quantité de la ligne',
    prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
    remiseLigneCommande: 'Remise de la ligne',
    tauxTvaLigneCommande: 'Taux de Tva de la ligne',
    dateDevisCommande: 'La date de la commande',
    dateSignature: 'Date signature',
    commentaireInterne: 'Commentaires interne',
    dateValidite: 'Date de validité',
    repartitionIntervenant: 'Quote-part facturation',
    tauxPenalite: 'Taux de pénalité',
    tauxEscompte: 'Taux d\'escompte',
    pourcentageRepartition: 'Pourcentage de répartition',
    etatSuiviId: 'L\'état de suivi dans les lignes de suivi administratif',
    assistant: 'Assistant(e)',
    commercial: 'Commercial(e)',
    demandeInterventionDemandeur: 'Commercial ou Assistant commercial',
    typeOt: 'Le type d\'ot de l\'intervention technique est manquant dans la configuraiton du produit',
    nomDispositif: 'Nom du Dispositif',
    materielTypeId: 'Type de matériel',
    dispositifTypeId: 'Type de dispositif',
    materielFormatId: 'Format',
  },
  annonceurWithSameExonerationTva: 'Tous les annonceurs doivent être éxonérés de TVA',
  ligneCommandeWithZeroTva: 'Si un annonceur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
  lockedClient: 'L\'intervenant {nomCommercial} est Totalement bloqué',
  productPurchase: 'Le produit {libelle} doit avoir un produit opposé de sens achat',
  Commande_ForbiddenToDeleteBilledTimetableLine: 'Il est interdit de supprimer une ligne échéance facturée',
  ligneCommandeWithoutLigneLocation: 'La vente du réseau {reseau} doit avoir une ligne location',
  remiseRegieshouldBeLast: 'La remise régie de la ligne {libelle} du produit {produit} doit être la dernière',
  remiseRegieOnlyOne: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle} du produit {produit}',
  remiseRegieMustBePreceded: 'La remise régie de la ligne {libelle} du produit {produit} doit être précédée d\'une ligne sous total',
  remiseRegieshouldBeLastWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être la dernière',
  ojectifNotAchieved: 'La vente du réseau "{reseau}" pour la semaine {semaine}-{annee} ne remplit pas l\'objectif de vente',
  remiseRegieOnlyOneWithoutRegroupement: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle}',
  remiseRegieMustBePrecededWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être précédée d\'une ligne sous total',
  commissionRefundGreaterThanFacture: 'Une erreur s\'est produite lors de l\'opération. Veuillez contacter le support pour plus d\'informations.',
  negativeNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande négative',
  negativeNormalCommandForbidden: 'Il est interdit d\'avoir une commande négative',
  ligneCommandeAchatLigneRapprocheeMustBeModified: 'Une ligne de commande rapprochée ou rapprochée partiellement ne doit pas être modifiée',
  dateFinEcheancierLigneNotBeLessThanDateDebut: 'La date de fin de la ligne d\'écheance pour du produit "{libelle}" ne peut être antérieure à sa date de début ({dateDebut}).',
  dateFinEcheancierLigneNotBeLessThanDateDebutMulti: 'La date de fin de la ligne d\'écheance ne peut être antérieure à sa date de début ({dateDebut}) pour les produits suivants : \n{libelle}',
  etatDeSuivi: 'Etat de suivi à la ligne : {ligne}',
  indexation: {
    commandesIndexationHasEcheancierGroupe: 'Les commandes suivantes ont un échéancier groupé: {codes}',
    commandeIndexationHasEcheancierGroupe: 'La commandes {code} a un échéancier groupé',
    commandeIndexationNotBeenIndex: 'La commande n\'est pas indexable',
    commandeIndexationTypesProduitsNotExist: 'Les types de produits sélectionnés ne font pas partie des produits indexables de la société',
    commandesIndexationFacturee: 'Les commandes suivantes sont facturées: {codes}',
    commandeIndexationFacturee: 'La commande {code} est facturée',
    commandesIndexationCantReset: 'Les commandes suivantes sont facturées: {codes}',
    commandeIndexationCantReset: 'La commande {code} est facturée',
    commandeWithDifferentIndice: 'Les commandes suivantes n\'ont pas le même indice: {codes}',
  },
  annonceurLieuStockageIsRequired: 'Au moins l\'un des annonceurs doit être un lieu de stockage.',
  ligneCommandeLinkToAnOT: 'La ligne de commande "{libelle}" est liée à un ordre de travail',
  SansSuiteForbiddenMoveWithValidationBlocage: 'Impossible de classer la commande sans suite car il a une ligne de vente réseau avec un état obtenu "Bloqué". Veuillez vous rapprocher de votre supérieur.',
  suppProduitRegroupementInDevisWithValidationModifBlocage: 'Impossible de supprimer une ligne de vente réseau avec un état obtenu "Bloqué". Veuillez vous rapprocher de votre supérieur.',
};

export const SUPPRESSION = {
  irreversible: 'La suppression de la commande est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer cette commande ?',
  irreversibleMultiple: 'La suppression des commandes irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces commandes ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la commande impossible.',
    errorTitleMultiple: 'Suppression des commandes impossible.',
    error: 'Veuillez réessayer ou contacter le service client.',
    success: 'Suppression de la commande réalisée avec succès.',
    successMultiple: 'Suppression des commandes réalisée avec succès.',
  },
  apiMessages: {
    DELETE_ORDER_UNAUTHORIZED: 'La suppression de le commande {param1} n\'est pas autorisée.',
  },
};

export const DETAIL_COMMANDE = {
  typeCommande: 'Commande',
  multiTypeCommande: 'Commandes ({nb})',
  tabs: {
    detail: 'Détail',
    previsualisation: 'Paramétrage édition',
    logistique: 'Logistique',
    achats: 'Achats',
    commissions: 'Commissions commercial',
    echeancierFacturation: 'Echéancier de Facturation',
    etatSuiviDevisCommande: 'Suivi administratif',
    signatureElectroniqueHisto: 'Signature',
    logistiqueImpression: 'Logistique d\'impression',
    achatVenteInterne: 'Ventes internes',
    lignesCommandeAchat: 'Ligne commande d\'achat',
  },
  actions: {
    goDevis: 'Revenir au devis',
  },
  popUpMail: {
    title: 'Rédiger votre email',
    inclureCommande: 'Inclure la commande',
    commandeObject: 'Commande {code} du {date}',
    contactTitle: 'Contacts commande',
  },
  achats: {
    titleMessage: 'Informations',
    message: 'Un regroupement personalisé n\'est pas affichable dans cet onglet, '
      + 'il faut dissocier la ligne de regroupement pour le voir apparaître',
    messageNoLigne: 'Aucun produit de la commande n\'est affichable, veuillez modifier votre commande',
    description: 'Description',
    montantHt: 'Montant HT',
    fournisseur: 'Fournisseur',
    aFacturer: 'A facturer',
    modeReglement: 'Mode de règlement',
    dateReglement: 'Date de règlement',
  },
  commission: {
    title: 'Commande de commission',
    breadcrumb: {
      title: 'Détail commande commission',
      liste: 'Liste des commandes',
    },
  },
  achatVenteInterne: {
    title: 'Commandes d\'achat',
    action: {
      generation: 'Re-générer commandes d\'achat et de vente interne',
      allGeneration: 'Re-générer toutes les commandes d\'achat et de vente interne',
      allCreation: 'Création des commandes d\'achat et de vente interne',
    },
    error: {
      noDelai: 'Le délai de règlement n\'est pas renseigné dans la configuration de vente interne de la société "{societeCourante}" pour la société "{societeTiers}"',
      noPaiementMethode: 'Le mode de règlement n\'est pas renseigné dans la configuration de vente interne de la société "{societeCourante}" pour la société "{societeTiers}"',
      noProvider: 'Le fournisseur n\'est pas renseigné dans la configuration de vente interne de la société "{societeCourante}" pour la société "{societeTiers}"',
      noSocieteTiers: 'La société n\'est pas configuré dans la configuration de vente interne',
      noAgency: 'L\'agence n\'est pas configurée dans la configuration de vente interne',
      noProduct: 'Un produit d\'achat manque sur une ligne de location ou divers',
      accountingAccountRequired: 'Le compte comptable du destinataire comptable est obligatoire.',
    },
    warning: {
      generation: 'Etes-vous sûr de vouloir re-génerer le(s) commande(s) d\'achat et de vente interne ?',
      creation: 'Etes-vous sûr de vouloir créer le(s) commande(s) d\'achat et de vente interne ?',
    },
    success: {
      generation: 'Re-génération réalisé avec succès',
      creation: 'Création réalisé avec succès',
    },
    tab: {
      fournisseur: 'Fournisseur',
      code: 'Commande achat',
      etat: 'Etat',
      montantHt: 'Montant HT',
      referenceFournisseur: 'Commande vente interne',
      status: 'Statut',
    },
    achat: {
      title: 'Détail de la commande d\'achat n°: {code}',
      breadcrumb: {
        title: 'Détail commande achat',
      },
      tab: {
        detail: 'Détail',
        echeancierFacturation: 'Echéancier de facturation',
      },
      steps: {
        infoGenerales: 'Informations générales',
        client: 'Client payeur',
        commande: 'Commande',
        echeancierFacturation: 'Echéancier facturation',
        pj: 'Pièces jointes',
      },
    },
    vente: {
      title: 'Détail de la commande vente interne n°: {code}',
      breadcrumb: {
        title: 'Détail commande vente interne',
        liste: 'Liste des commandes',
      },
      tab: {
        detail: 'Détail',
        echeancierFacturation: 'Echéancier de facturation',
      },
      steps: {
        infoGenerales: 'Informations générales',
        client: 'Client payeur',
        commande: 'Commande',
        echeancierFacturation: 'Echéancier facturation',
        pj: 'Pièces jointes',
      },
    },
  },
  generalTitle: {
    achat: 'Achats',
  },
  facturer: {
    actions: {
      genererFactureZero: 'Générer les factures même si le montant est à 0',
      redirectionFacture: 'Re-diriger vers la/les facture(s) générée(s)',
      genererUneSeuleFacture: 'Emettre une seule facture',
    },
  },
  dupliquer: {
    title: 'Dupliquer la commande n°{code}',
    dateCampagne: 'Nouvelle date de campagne',
  },
  popUpDeCloture: {
    mess: 'Etes-vous sûr de vouloir réactiver cette commande ?',
    success: 'Commande réactivée avec succès',
  },
  indexation: {
    title: 'Indexation',
    nomIndice: 'Nom de l\'indice',
    valeurIndexationReference: 'Valeur d\'indice de référence',
    dateIndexationReference: 'Date de l\'indice de référence',
    dateDerniereIndexation: 'Date dernière indexation',
    valeurIndexationActuel: 'Valeur d\'indice actuel',
    dateIndexationActuel: 'Date de l\'indice actuel',
    pourcentageTheorique: 'Pourcentage d\'augmentation (%)',
    pourcentageReel: 'Pourcentage personnalisé (%)',
    successIndexationMsg: 'La commande a été indexé avec succès',
    successIndexationMasseMsg: 'Les commandes ont été indexés avec succès',
    affichageDonneeIndexation: 'Afficher les données de l\'indexation',
    errorIndexationMsg: 'Impossible d\'indexer la commande',
    montantReference: 'Montant de référence',
    montantActuel: 'Montant actuel',
    popUp: {
      title: 'Indexation de la commande',
      titleEcheancier: 'Détail de l\'indexation',
      tabIndexation: 'Indexation',
      tabEcheancier: 'Echéancier ({nb})',
      dateIndexation: 'Date de l\'indexation',
      typesProduits: 'Types de produits',
      valeurIndexationReference: 'Valeur d\'indice de référence',
      dateIndexationActuel: 'Date de l\'indice actuel',
      valeurIndexationActuel: 'Valeur d\'indice actuel',
      pourcentageTheorique: 'Pourcentage d\'augmentation (%)',
      pourcentageReel: 'Pourcentage personnalisé (%)',
      informationReference: 'Informations indice de reference',
      informationActuel: 'Informations indice actuel',
    },
    popUpEcheancier: {
      dateFin: 'Fin',
      dateDebut: 'Début',
      payeur: 'Payeur',
      montant: 'Montant période',
      montantIndexe: 'Montant indexé',
      produit: 'Produit',
      echeancierNonIndexable: 'Cette écheance ne sera pas indexée',
    },
  },
  resetIndexation: {
    messageResetSuccess: 'La dernière indexation a été annulée avec succès',
  },
  commandeAchat: {
    table: {
      code: 'N° commande',
      dateDevisCommande: 'Date de commande',
      listeIntervenants: 'Fournisseur(s)',
      produitsLibelle: 'Produit(s)',
      etat: 'Etat',
      montantHt: 'Montant HT',
    },
    filtre: {
      etat: 'Etat(s)',
      code: 'Code commande',
      fournisseur: 'Fournisseur(s)',
      dateCommande: 'Date de commande',
      produits: 'Produit(s)',
    },
    addCommande: 'Ajouter une commande d\'achat',
  },
  ligneCommandeAchat: {
    title: 'Ligne de commande d\'achat',
    tab: {
      codeCommande: 'N° commande',
      libelleProduit: 'Produit d\'achat',
      libelle: 'Libellé ligne',
      listeIntervenants: 'Fournisseur',
      etat: 'Etat ligne',
      quantite: 'Quantité',
      prixUnitaire: 'Prix unitaire',
      totalHt: 'Montant HT',
    },
    filtre: {
      code: 'Code commande',
      libelle: 'Libellé ligne',
      libelleProduit: 'Libellé produit',
      fournisseur: 'Fournisseur(s)',
      produits: 'Produit(s)',
      etat: 'Etat(s)',
    },
  },
};

export const ECHEANCIER_FACTURATION = {
  title: 'Paramétrages échéancier',
  actions: {
    fusion: 'Créer un échéancier groupé',
    defusion: 'Dégrouper',
    majDateFacturation: 'Mise à jour de la date de facturation',
    delete: 'Supprimer',
    addEcheance: 'Ajouter une échéance',
    create: 'Créer un échéancier',
    regenerate: 'Regénérer l\'échancier',
    cancel: 'Annuler',
    gestionEcheancier: 'Gérer l\'échéancier',
    gestionCommentaire: 'Gérer le(s) commentaire(s)',
    gestionCommentaireUnitaire: 'Gérer le commentaire',
    genererEcheancierMasse: 'Générer des échéanciers',
    supprimerEcheancierMasse: 'Supprimer des échéanciers',
  },
  tabs: {
    products: 'Produit(s)',
    montant: 'Mnt HT total',
    echeancier: 'Echéancier',
    datePrev: 'Date prév. de facturation',
    datePatri: 'Du {date}',
    fournisseur: 'Fournisseur',
    aFacturer: 'A facturer',
    valDiff: 'Valeurs différentes',
    commentaire: 'Commentaire',
  },
  tabsEcheancierLignes: {
    payeur: 'Payeur',
    montant: 'Montant échéance',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    aFacturer: 'A facturer le',
    facturer: 'Facturation',
    facturerDevis: 'Facturée le',
    dateFacture: 'le {dateFacture}',
    totalPayeur: 'Total {nomCommercial} - {quotePart}',
    total: 'Total',
    commentaire: 'Commentaire',
  },
  indicateurFacturation: 'Facturée sans facture',
  popUpEcheancierManuel: {
    title: 'Paramétrage de l\'écheancier',
    debut: 'Début de l\'écheancier',
    fin: 'Fin de l\'écheancier',
    datePremiereEcheance: 'Date de fin de 1ère échéance',
    tousLes: 'Tous les',
    periodicite: 'Périodicité',
    montant: 'Montant',
    actions: {
      cancel: 'Annuler',
      generer: 'Générer l\'échéancier',
    },
  },
  popUpGestionCommentaire: {
    title: 'Modifier le commentaire de facturation',
    commentaire: 'Commentaire',
  },
  popUpDateFacturation: {
    title: 'Modifier la date de facturation',
    indication: 'La fonction ne modifie que les échéanciers automatiques non facturés',
    dateFacturation: 'Date de facturation',
    error: 'La date de facturation est obligatoire',
    success: 'Date de facturation modifiée avec succées',
  },
  messages: {
    noLignesVentesAndNoPayeur: 'Ajoutez des lignes de ventes et au moins un payeur pour pouvoir gérer vos échéancier de facturation',
    noGestionEcheancier: 'Vous ne souhaitez pas gérer l\'échéancier de facturation dans votre devis',
    errors: {
      startGreaterThanEnd: 'La date de début doit être antérieure à la date de fin.',
      firstEndDateOutsideRange: 'La date de fin de première échéance doit être comprise entre la date de début et la date de fin.',
      payer: 'Il faut au moins un payeur sur la ligne d\'échéance',
      pourcentageDivision: 'La répartition des payeurs n\'est pas de 100%.',
      amount: 'Le montant doit être positif.',
      divisionType: 'Les payeurs doivent avoir le même type de répartition.',
      totalDifferent: 'La somme des échéances est différente du montant total de l\'échéancier.',
      required: {
        dateDebut: 'Date de début.',
        dateFin: 'Date de fin.',
        quotePart: 'Quote-part de facturation du payeur',
        montant: 'Montant',
        quantitePeriodicite: 'Veuillez renseigner une périodicité.',
        dateDebutEcheance: 'Date de début pour chaque ligne d\'échéances',
        dateFinEcheance: 'Date de fin pour chaque ligne d\'échéances',
        dateFinPremiereEcheance: 'Date prévisionnelle de facturation pour chaque ligne d\'échéances',
        payeur: 'Payeur pour chaque ligne d\'échéances',
        commentaireFacturation: 'Commentaire de facturation',
      },
      onlyEcheancierAuto: {
        title: 'Impossible de grouper des échéanciers déjà générés',
        subTitle: 'Veuillez grouper des échéanciers qui n\'ont pas été déjà générés',
      },
      defusion: {
        title: 'Impossible de dégrouper un échéancier qui n\'a pas été groupé',
        subTitle: 'Veuillez dégrouper uniquement des échéanciers déjà groupés',
      },
      fusionWithLigneFacture: {
        title: 'Impossible de grouper les échéanciers',
        subTitle: 'Un des échéanciers possède au moins une ligne facturée',
      },
      generationEcheancierWithLigneFacture: {
        title: 'Impossible de générer des échéanciers',
        subTitle: 'Un des échéanciers possède au moins une ligne facturée',
      },
      suppressionEcheancierWithLigneFacture: {
        title: 'Impossible de supprimer des échéanciers',
        subTitle: 'Un des échéanciers possède au moins une ligne facturée',
      },
      fusionWithAFacturerFournisseurDiff: {
        title: 'Impossible de grouper les échéanciers',
        subTitle: 'Les échéanciers doivent avoir la même valeur de \'A facturer\' et le même fournisseur',
      },
      defusionWithLigneFacture: {
        title: 'Impossible de dégrouper l\'échéancier',
        subTitle: 'L\'échéancier possède au moins une ligne facturée',
      },
      payeurDelete: {
        title: 'Vous ne pouvez pas supprimer ce client car il est présent dans un échéancier',
        subTitle: 'Veuillez d\'abord le supprimer du ou des échéanciers.',
      },
      payeurDeselect: {
        title: 'Vous ne pouvez pas déselectionner ce payeur car il est présent dans un échéancier',
        subTitle: 'Veuillez d\'abord le supprimer du ou des échéanciers.',
      },
    },
    prevention: {
      defusion: {
        title: 'Etes-vous sûr de vouloir dégrouper l’échéancier de facturation ?',
        subTitle: 'Lorsque vous dégrouper un échéancier, vous perdrez le mode de répartition ainsi que vos échéances de facturation.',
      },
      suppression: {
        title: 'Etes-vous sûr de vouloir supprimer l’échéancier de facturation ?',
        subTitle: 'Lorsque vous supprimer un échéancier, vous perdrez le mode de répartition ainsi que vos échéances de facturation.',
      },
      suppressions: {
        title: 'Etes-vous sûr de vouloir supprimer des échéanciers de facturation ?',
        subTitle: 'Lorsque vous supprimer un échéancier, vous perdrez le mode de répartition ainsi que vos échéances de facturation.',
      },
      total_different: {
        title: 'Le montant total des échéances d’un échéancier est différent du montant total de l\'échéancier',
        subTitle: 'Souhaitez-vous continuer ?',
      },
      unconsecutive_date: {
        title: ' Certaines échéances d’un même échéancier ne sont pas consécutives',
        subTitle: 'Souhaitez-vous continuer ?',
      },
    },
    success: {
      fusion: 'L\'échéanchier a été groupé avec succès',
      defusion: 'L\'échéanchier a été dégroupé avec succès',
      generation: 'L\'échéancier a été généré avec succès',
      suppresion: 'L\'échéancier a été supprimé avec succès',
      suppresions: 'Les échéanciers ont été supprimés avec succès',
      editCommentaire: 'Le(s) commentaire(s) ont été modifié(s) avec succès',
    },
  },
};
